export default function LabelValorWide({ label, valor }) {
  return (
    <div>
      <div className="label">{label}</div>
      <div className="valor">{valor}</div>
    </div>
  );
}
